<template>
  <div class="home">
    <NotificationList v-show="listView" @newNotif="onClickNewFromList" @editNotif="onClickEditFromList" ref="refreshList"/>
    <NotificationForm v-show="formView" :notif="notif" @backClicked="onBackChild" @backParentID="backParentID"/>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import NotificationList from '@/components/notif/NotificationList.vue'
import NotificationForm from '@/components/notif/NotificationForm.vue'
import { getHeader, notifUrl } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'Notification',
  components: {
    NotificationList,
    NotificationForm
  },
  data () {
    return {
      listView: true,
      formView: false,
      notif: {
        id: null,
        template_no: null,
        template: null,
        number: null,
        message: null,
        status: null,
        date: null,
        check: null,
        ref_no: null,
        ref_note: null
      }
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  },
  methods: {
    backParentID: function (id) {
      axios.get(notifUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.notif = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      this.listView = false
      this.formView = true
      this.notif = value
    },
    getEdit: function (value) {
      console.log(notifUrl + '/' + value)
      axios.get(notifUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.listView = false
          this.formView = true
          this.notif = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      this.listView = false
      this.formView = true
      this.notif = {
        id: null,
        template_no: null,
        template: null,
        number: null,
        message: null,
        status: null,
        date: null,
        check: null,
        ref_no: null,
        ref_note: null
      }
    },
    onBackChild: function () {
      this.listView = true
      this.formView = false
      this.notif = {
        id: null,
        template_no: null,
        template: null,
        number: null,
        message: null,
        status: null,
        date: null,
        check: null,
        ref_no: null,
        ref_note: null
      }
      this.$refs.refreshList.refreshList()
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
  }
}
</script>
